export default function MySQL_NULLIF() {
  return (
    <div>
      <h2>MySQL_NULLIF</h2>    </div>
  );
}